<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.candidates.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton color="danger" v-c-tooltip="$lang.buttons.export.pdf"
                           v-on:click="exports(self,'pdf',module,'Candidates',self.userId)">
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv class="btn btn-success" v-c-tooltip="$lang.buttons.export.excel" :json-data="json_data"
                                :labels="json_label" :csv-title="json_title">
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
                <BeforeFilter :filterShow="toggleFilterValue" @getFilterToggle="switchFilter"></BeforeFilter>
              </div>
            </CCol>
          </div>
        </CCardHeader>

        <CCardBody>
          <transition name="fade">
            <CRow v-if="toggleFilterValue">

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.companyList }}</label>
                  <v-select :options="list" v-model="filter.list"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.experience }}</label>
                  <v-select :options="experienceList" v-model="filter.experienceList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.jobType }}</label>
                  <v-select :options="jobTypeList" v-model="filter.jobTypeList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.commissionType }}</label>
                  <v-select :options="commissionTypeList" v-model="filter.commissionTypeList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.workType }}</label>
                  <v-select :options="workTypeList" v-model="filter.workTypeList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.requirement }}</label>
                  <v-select :options="availabilityList" v-model="filter.availabilityList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.currency }}</label>
                  <v-select :options="currencyList" v-model="filter.currencyList"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{ $lang.candidates.filter.title }}</label>
                  <input type="text" class="form-control" v-model="filter.title"/>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group" style="margin-top: 30px">
                  <CButton
                      type="submit"
                      size="sm"
                      color="primary"
                      @click="applyFilter()"
                      v-c-tooltip="$lang.common.filter.button.filter"
                  >
                    {{ $lang.common.filter.button.filter }}
                  </CButton> &nbsp;
                  <CButton color="danger" size="sm" @click="resetFilter()"
                           v-c-tooltip="$lang.common.filter.button.cancel">
                    {{ $lang.common.filter.button.cancel }}
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </transition>

          <CAlert color="success" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}</CAlert>

          <v-server-table :columns="columns" :url="listUrl" :options="options" ref="myTable"
                          @loaded="exports(self,'Excel',module,'Candidates',self.userId)">

            <template #description="data">
              <span :title="data.row.description">{{ trimfunction(data.row.description, 20) }}</span>
            </template>
            <template #minSalary="data">
              <span>{{ data.row.minSalary }}</span>
            </template>
            <template #maxSalary="data">
              <span>{{ data.row.maxSalary }}</span>
            </template>
            <template #experience="data">
              <span>{{ data.row.experience.title }}</span>
            </template>
            <template #firstName="data">
              <Avatar
                  :image="data.row.avatar"
                  :defaultImage="data.row.avatar"
                  :content="data.row.firstName"
                  :allowCompany="true"
                  :length="20"
              />
            </template>
            <template #actions="data">
              <!--v-if='checkPermission("view-post")'-->
              <CButton
                  color="primary"
                  v-c-tooltip="$lang.buttons.general.crud.view"
                  v-on:click="viewJob(data.row.id,data.row.userId)"
                  v-if="checkPermission('list-candidate')"
              >
                <i class="fas fa-eye"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
                  v-if="checkPermission('list-candidate')"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {
  Candidates
} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import BeforeFilter from "/src/views/BeforeFilterOpen";
import VueJsonToCsv from "vue-json-to-csv";
import Avatar from "/src/components/Avatar";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "CandidateTab",
  mixins: [Mixin],
  components: {
    BeforeFilter,
    VueJsonToCsv,
    Avatar,
  },
  data() {
    return {
      selectedColumns: [],
      iAmUser: "",
      userId: "",
      listUrl: "",
      list: [],
      experienceList: [],
      commissionTypeList: [],
      workTypeList: [],
      availabilityList: [],
      currencyList: [],
      jobTypeList: [],
      json_data: [],
      json_label: {},
      json_title: "",
      toggleFilterValue: false,
      range: [0, 1000000],
      number: 1,
      err_msg: "",
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      jobData: [],
      requirement: [],
      worktype: [],
      activePage: 1,
      module: Candidates,
      filter: {
        type: "",
        list: "",
        experienceList: "",
        commissionTypeList: "",
        jobTypelist: "",
        title: "",
        workTypeList: "",
        availabilityList: "",
        currencyList: "",
      },
      recruiters: {
        registeredType: "",
        firstName: "",
        company: "",
      },
      columns: [
        "company",
        "firstName",
        "jobType",
        "title",
        "experience",
        "minSalary",
        "maxSalary",
        "commissionType",
        "commissionPer",
        "commissionMonth",
        "createdAt",
        "updatedAt",
        "actions",
      ],
      data: [],
      options: {
        headings: {
          company: this.$lang.candidates.table.company,
          firstName: this.$lang.candidates.table.firstName,
          jobType: this.$lang.candidates.table.jobtype,
          title: this.$lang.candidates.table.title,
          minSalary: this.$lang.candidates.table.minSalary,
          maxSalary: this.$lang.candidates.table.maxSalary,
          experience: this.$lang.candidates.table.experience,
          commissionType: this.$lang.candidates.table.commissionType,
          commissionPer: this.$lang.candidates.table.commission,
          commissionMonth: this.$lang.candidates.table.commissionMonth,
          createdAt: this.$lang.candidates.table.added,
          updatedAt: this.$lang.candidates.table.updated,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: [],
        sortable: [
          "title",
        ],
        filterable: [],
      },
    };
  },
  created() {
    let self = this;
    self.listUrl = "/candidates/list/";
    self.userId = this.$route.params.user_id;
    if (self.userId) {
      self.listUrl = this.listUrl + self.userId;
    } else {
      self.listUrl = this.listUrl;
    }
    this.getList('Company');
  },
  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    store.commit("showLoader", false);
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    getList(type) {
      let self = this;
      self.userList = "/candidates/list/";
      axios.get(self.userList)
          .then((response) => {
            let responseData = response.data;
            responseData.data.map(function (value, key) {
              if (type === 'Company') {
                self.list.push({value: value.companyId, label: value.company});
              }
              self.experienceList.push({value: value.experience.id, label: value.experience.title});
              self.commissionTypeList.push({value: value.commissionType, label: value.commissionType});
              self.jobTypeList.push({value: value.jobTypeShortName, label: value.jobType});
              self.workTypeList.push({value: value.worktype.id, label: value.worktype.title});
              self.availabilityList.push({value: value.availability.id, label: value.availability.title});
              self.currencyList.push({value: value.currency.id, label: value.currency.currencySymbol});
            });
            self.list = this.removeDuplicateValues(self.list);
            self.experienceList = this.removeDuplicateValues(self.experienceList);
            self.commissionTypeList = this.removeDuplicateValues(self.commissionTypeList);
            self.jobTypeList = this.removeDuplicateValues(self.jobTypeList);
            self.workTypeList = this.removeDuplicateValues(self.workTypeList);
            self.availabilityList = this.removeDuplicateValues(self.availabilityList);
            self.currencyList = this.removeDuplicateValues(self.currencyList);
            // console.log(self.experienceList);
          });
    },
    /* get from child component */
    switchFilter(show) {
      this.toggleFilterValue = show;
    },
    applyFilter() {
      let self = this;
      let reqObj = {
        registeredType: 'Company',
        id: self.filter.list?.value,
        experienceId: self.filter.experienceList?.value,
        commissionType: self.filter.commissionTypeList?.value,
        jobType: self.filter.jobTypeList?.value,
        workType: self.filter.workTypeList?.value,
        availability: self.filter.availabilityList?.value,
        currency: self.filter.currencyList?.value,
        title: (self.filter.title) ? self.filter.title : null,
      };
      store.commit("showLoader", true); // Loader Start
      this.$refs.myTable.customQueries = reqObj;
      this.$refs.myTable.refresh();
    },
    resetFilter() {
      let self = this;
      self.filter.title = null;
      self.filter.list = [];
      self.filter.experienceList = [];
      self.filter.commissionTypeList = [];
      self.filter.jobTypeList = [];
      self.filter.workTypeList = [];
      self.filter.availabilityList = [];
      self.filter.currencyList = [];
      store.commit("showLoader", true); // Loader Start
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();

    },
    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios.delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                if (response.status === 200) {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.response.message;
                  self.dismissCountDownS = 10;
                }
              });
        }
      });
    },
    viewJob(id, userId) {
      this.$router.push({path: `candidate/view/${id}/${userId}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
  },
};
</script>
